<div class="flex flex-col gap-2 min-h-[14rem]">
  <taures-message severity="success" header="Bewerbung erfolgreich eingereicht">
    <p>Vielen Dank! Wir haben deine Bewerbung erhalten und melden uns in Kürze bei dir zurück.</p>
  </taures-message>

  <div class="flex justify-end mt-auto">
    <p-button type="button" [routerLink]="['../landing']" label="Zurück" />
  </div>
</div>
